export const getDistanceFromCommunity = (lat1: number, lon1: number, lat2: number, lon2: number) => {
  if (isNaN(lat1) || isNaN(lon1) || isNaN(lat2) || isNaN(lon2)) return null;

  const R = 6371; // Earth's radius in kilometers

  const toRadians = (deg: number) => deg * (Math.PI / 180);

  const phi1 = toRadians(lat1);
  const phi2 = toRadians(lat2);
  const deltaPhi = toRadians(lat2 - lat1);
  const deltaLambda = toRadians(lon2 - lon1);

  const a = Math.sin(deltaPhi / 2) ** 2 + Math.cos(phi1) * Math.cos(phi2) * Math.sin(deltaLambda / 2) ** 2;

  const c = 2 * Math.atan2(Math.sqrt(a), Math.sqrt(1 - a));

  return R * c;
};

export const metersToLatDegrees = (m: number) => m / 111_320; // ~ meters per 1° lat
export const metersToLngDegrees = (m: number, lat: number) => m / (111_320 * Math.cos((lat * Math.PI) / 180));

type PairKey = `${number}-${number}`;

export const distanceKey = (a: number, b: number): PairKey => `${a}-${b}` as const;
